var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class RefsManager {
  constructor(base, element, refs, eventsManager) {
    __publicField(this, "__element");
    __publicField(this, "__refs");
    __publicField(this, "__base");
    __publicField(this, "__eventsManager");
    Object.defineProperties(this, {
      __element: {
        enumerable: false,
        writable: false,
        value: element
      },
      __refs: {
        enumerable: false,
        writable: false,
        value: refs
      },
      __base: {
        enumerable: false,
        writable: false,
        value: base
      },
      __eventsManager: {
        enumerable: false,
        writable: false,
        value: eventsManager
      }
    });
  }
  registerAll() {
    this.__refs.forEach((refName) => this.__register(refName));
  }
  unregisterAll() {
    this.__refs.forEach((refName) => this.__unregister(refName));
  }
  __register(refName) {
    const isMultiple = refName.endsWith("[]");
    const propName = RefsManager.normalizeRefName(refName);
    const refs = Array.from(this.__element.querySelectorAll(`[data-ref="${refName}"]`)).filter((ref) => this.__filterRefsBelongingToInstance(ref));
    if (!isMultiple && refs.length > 1) {
      console.warn(`[${this.__base.$options.name}]`, `The "${refName}" ref has been found multiple times.`, "Did you forgot to add the `[]` suffix to its name?");
    }
    if (!isMultiple && refs.length <= 1 && refs[0] === void 0) {
      console.warn(`[${this.__base.$options.name}]`, `The "${refName}" ref is missing.`, `Is there an \`[data-ref="${refName}"]\` element in the component's scope?`);
      return;
    }
    this.__eventsManager.bindRef(refName, refs);
    Object.defineProperty(this, propName, {
      value: isMultiple || refs.length > 1 ? refs : refs[0],
      enumerable: true,
      configurable: true
    });
  }
  __unregister(refName) {
    const propName = RefsManager.normalizeRefName(refName);
    const refs = Array.isArray(this[propName]) ? this[propName] : [this[propName]];
    this.__eventsManager.unbindRef(refName, refs);
  }
  static normalizeRefName(name) {
    return name.endsWith("[]") ? name.replace(/\[\]$/, "") : name;
  }
  __filterRefsBelongingToInstance(ref) {
    let ancestor = ref.parentElement;
    while (ancestor && ancestor.dataset.component === void 0) {
      ancestor = ancestor.parentElement;
    }
    return ancestor === null || ancestor === this.__element;
  }
}
export {
  RefsManager as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
